/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from "react";
import "../assets/Loan/LoanDocuments.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllLoans } from "../redux/slices/loan/loanReportSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortUp } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const LoanDocuments = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loans, loading, error } = useSelector((state) => state.loanReport);

  const [filters, setFilters] = useState({
    loanAccountNumber: "",
    customerName: "",
  });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50,100,500];

  useEffect(() => {
    dispatch(fetchAllLoans());
  }, [dispatch]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const applyFilters = (loan) => {
    const { loanAccountNumber, customerName } = filters;

    const isLoanAccountMatch =
      !loanAccountNumber ||
      loan.loanAccountNumber
        ?.toLowerCase()
        .includes(loanAccountNumber.toLowerCase());

    const isCustomerNameMatch =
      !customerName ||
      loan.userName?.toLowerCase().includes(customerName.toLowerCase());

    return isLoanAccountMatch && isCustomerNameMatch;
  };

  const filteredLoans = Array.isArray(loans) ? loans.filter(applyFilters) : [];

  // ✅ Navigation with full loan object and superAdminId
const goToSanction = (loan) =>
  navigate(`/Banking/OpenAccount/Sanction/${loan.id}`, {
    state: {
      loan,
      customerId: loan.customerId,
      superAdminId: loan.superAdminId, // ✅ added
    },
  });

const goToPromises = (loan) =>
  navigate(`/Banking/OpenAccount/Promises/${loan.id}`, {
    state: {
      loan,
      customerId: loan.customerId,
      superAdminId: loan.superAdminId, // ✅ added
    },
  });

const goToAgreement = (loan) =>
  navigate(`/Banking/OpenAccount/Agreement/${loan.id}`, {
    state: {
      loan,
      customerId: loan.customerId,
      superAdminId: loan.superAdminId, // ✅ added
    },
  });

const goToNoc = (loan) =>
  navigate(`/Loan/LoanClosing/NOCLetter`, {
    state:loan,
  });



    // Search + Pagination
  
    const totalPages = Math.ceil(filteredLoans.length / itemsPerPage);
  
    const paginatedData = filteredLoans.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  
    const handleItemsPerPageChange = (e) => {
      setItemsPerPage(Number(e.target.value));
      setCurrentPage(1);
    };

  return (
    <div className="ram-tech-BranchLoanReport-container">
      <h2 style={{textAlign:"center"}}>Loan Documents</h2>
      {/* Filter Section */}
      <section className="ram-tech-BranchLoanReport-filter">
        {/* <h2 className="ram-tech-BranchLoanReport-filter-title">
          Loan Report Filter
        </h2>
        <p className="ram-tech-BranchLoanReport-filter-subtitle">
          Use filters to view specific loan reports
        </p> */}

        <form
          className="ram-tech-BranchLoanReport-form"
          autoComplete="off"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="ram-tech-BranchLoanReport-form-group">
            <label htmlFor="loanAccountNumber">Loan Account Number</label>
            <input
              type="text"
              id="loanAccountNumber"
              name="loanAccountNumber"
              placeholder="Enter loan account number"
              value={filters.loanAccountNumber}
              onChange={handleInputChange}
            />
          </div>

          <div className="ram-tech-BranchLoanReport-form-group">
            <label htmlFor="customerName">Customer Name</label>
            <input
              type="text"
              id="customerName"
              name="customerName"
              placeholder="Enter customer name"
              value={filters.customerName}
              onChange={handleInputChange}
            />
          </div>

          <div className="ram-tech-BranchLoanReport-actions">
            <button
              type="submit"
              className="ram-tech-BranchLoanReport-btn-submit"
            >
              Submit
            </button>
          </div>
        </form>
      </section>

      {/* Filter */}
      <div className="loan-documents-filter-div">
              <label>Show </label>
              <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
                {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                  <option key={num} value={num}>{num}</option>
                ))}
                <option value="100000">ALL</option>
              </select>
              <span> entries</span>
          </div>


      {/* Loan Details Section */}
      <section className="ram-tech-BranchLoanReport-details">
        <h2 className="ram-tech-BranchLoanReport-details-title">
          Loan Details
        </h2>

        <div className="ram-tech-BranchLoanReport-export-buttons"></div>

        <div className="ram-tech-BranchLoanReport-table-wrapper">
          <table className="ram-tech-BranchLoanReport-table">
            <thead>
              <tr>
                <th>
                  SN. <FontAwesomeIcon icon={faSortUp} />
                </th>
                <th>CUS ID</th>
                <th>Account Number</th>
                <th>Loan Id</th>
                <th>Customer Name</th>
                <th>Loan Amount</th>
                <th>Loan Scheme</th>
                <th>Loan Type</th>
                <th>Loan Status</th>
                <th>Documents</th>
                {/* <th>Sanction</th>
                <th>Promise</th>
                <th>Loan Agreement</th> */}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="12">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="12" style={{ color: "red" }}>
                    {error}
                  </td>
                </tr>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((loan, index) => {
                  const rowStyle = {
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#eaf3ff",
                    color: "#1f2937",
                  };

                  return (
                    <tr key={loan.id || index} style={rowStyle}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{loan.customerId || "N/A"}</td>
                      <td>{loan.loanAccountNumber || "N/A"}</td>
                      <td>{loan.id || "N/A"}</td>
                      <td>{loan.userName || "N/A"}</td>
                      <td>
                        ₹{Number(loan.loanAmount || 0).toLocaleString("en-IN")}
                      </td>
                      <td>{loan.loanService ?? "N/A"}</td>
                      <td>{loan.loanType || "N/A"}</td>
                      <td>{loan.status || "N/A"}</td>

                      {/* ✅ Buttons pass full loan object */}
                      <td>
                        <div style={{ display: "flex", gap: "5px",justifyContent:"center" }}>
                        {(loan.status.toLowerCase()==="disbursed"||loan.status.toLowerCase()==="approved")&&(
                          <button
                            className="ram-tech-BranchLoanReport-btn-action"
                            onClick={() =>  navigate(`/Loan/LoanApplicationForm/${loan.id}`, { state: { loan } })}
                          >
                            Loan Application
                          </button>
                        )}
                        {(loan.status.toLowerCase() === "active" || loan.status.toLowerCase() === "disbursed") && (
                          <div style={{ display: "flex", gap: "5px",justifyContent:"center" }}>
                          <button
                            className="ram-tech-BranchLoanReport-btn-action"
                            onClick={() =>  navigate(`/Loan/LoanCard/${loan.id}`, { state: { loan } })}
                          >
                            Loan Card
                          </button>
                          <button
                            className="ram-tech-BranchLoanReport-btn-action"
                            onClick={() =>  navigate(`/Print/LoanStatement/${loan.id}`, { state: { loan } })}
                          >
                            Loan Statement
                          </button>
                          <button
                            className="ram-tech-BranchLoanReport-btn-action"
                            onClick={() =>  navigate(`/Loan/LoanPassbook/${loan.id}`, { state: { loan } })}
                          >
                            Loan Passbook
                          </button>
                          <button
                            className="ram-tech-BranchLoanReport-btn-action"
                            onClick={() => goToSanction(loan)}
                          >
                            Sanction
                          </button>
                          <button
                            className="ram-tech-BranchLoanReport-btn-action-loan-card"
                            onClick={() => goToPromises(loan)}
                          >
                            Promises
                          </button>
                           <button
                            className="ram-tech-BranchLoanReport-loan-application-button"
                            onClick={() => goToAgreement(loan)}
                          >
                            Agreement
                          </button>
                          </div>
                        )}
                        {(loan.status.toLowerCase()==="closed" || loan.status.toLowerCase()==="settled") && (
                          <button
                            className="ram-tech-BranchLoanReport-btn-action"
                            onClick={() => goToNoc(loan)}
                          >
                            NOC Letter
                          </button>
                        )}
                                                </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="12">No loan records found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

{/* pagination */}
      {filteredLoans.length > itemsPerPage && (
            <div className="loan-documents-pagination-div">
              <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
                ⬅ Prev
              </button>

              <span> Page {currentPage} of {totalPages} </span>

              <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
                Next ➡
              </button>
            </div>
          )}
    </div>
  );
};

export default LoanDocuments;
